/* src/app/core/components/top-nav/top-nav.component.scss */
li.li-hover:hover > a,
li.dropdown-item:not(.dropdown-item__heading):hover {
  color: #fff;
}
.fs-md {
  font-size: 16px;
}
header .dropdown {
  border-bottom: none !important;
}
@media (max-width: 767px) {
  .dropdown > a {
    border-radius: 5px !important;
  }
  a > div.d-flex {
    padding: 0.5rem;
  }
  .navbar-nav {
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
  }
}
/*# sourceMappingURL=top-nav.component.css.map */
